var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Calendar_2080321_1_",
    "data-name": "noun_Calendar_2080321 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.255,
    height: 23.311,
    viewBox: "0 0 24.255 23.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M23.745,6.111H20.608V5.448a1.148,1.148,0,1,0-2.3,0v.663H10.891V5.448a1.148,1.148,0,1,0-2.3,0v.663H5.484A2.988,2.988,0,0,0,2.5,9.095V24.627a2.988,2.988,0,0,0,2.984,2.984H23.771a2.988,2.988,0,0,0,2.984-2.984V9.095A3.01,3.01,0,0,0,23.745,6.111ZM5.484,8.406H8.621v.663a1.148,1.148,0,1,0,2.3,0V8.406h7.422v.663a1.148,1.148,0,1,0,2.3,0V8.406h3.137a.686.686,0,0,1,.689.689V12.13H4.8V9.095A.686.686,0,0,1,5.484,8.406ZM23.745,25.316H5.484a.686.686,0,0,1-.689-.689V14.4H24.459V24.627A.725.725,0,0,1,23.745,25.316Z",
    transform: "translate(-2.5 -4.3)",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.102038ba5780aa3a1e3f047f265082cb.svg";
export { ForwardRef as ReactComponent };